import React, { lazy, Suspense, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import RequireAuth from '@components/RequireAuth/RequireAuth';
import LoadingScreen from '@components/LoadingScreen/LoadingScreen';
import ReportAutorizationPage from 'pages/reportAutorization/ReportAutorizationPage';

const SearchPatientPage = lazy(() => import('./pages/searchPatientPage/SearchPatientPage'));
const PreparationRequestPage = lazy(() => import('./pages/preparationRequest/PreparationRequestPage'));
const ApplicationListPage = lazy(() => import('./pages/applicationList/ApplicationListPage'));
const ComApplicationListPage = lazy(() => import('./pages/comApplicationList/ComApplicationListPage'));
const ReportListPage = lazy(() => import('./pages/reportList/ReportListPage'));
const ReprintsPage = lazy(() => import('./pages/reprints/ReprintsPage'));
const PrintingPage = lazy(() => import('./pages/printing/PrintingPage'));
const StoreCampaingListPage = lazy(() => import('./pages/storeCampaingList/StoreCampaingListPage'));
const ElaborationListPage = lazy(() => import('./pages/elaborationList/ElaborationListPage'));
const PickingListPage = lazy(() => import('./pages/pickingList/PickingListPage'));
const SanitationIListPage = lazy(() => import('./pages/sanitationIList/SanitationIListPage'));
const SanitationIIListPage = lazy(() => import('./pages/sanitationIIList/SanitationIIListPage'));
const PreElaborationListPage = lazy(() => import('./pages/preElaborationList/PreElaborationListPage'));
const ProductionListPage = lazy(() => import('./pages/productionList/ProductionListPage'));
const PostElaborationListPage = lazy(() => import('./pages/postElaborationList/PostElaborationListPage'));
const LabeledListPage = lazy(() => import('./pages/labeledList/LabeledListPage'));
const ValidationListPage = lazy(() => import('./pages/validationList/ValidationListPage'));
const LiberationListPage = lazy(() => import('./pages/liberationList/LiberationListPage'));
const ValidationReportListPage = lazy(() => import('./pages/validationReportList/ValidationReportListPage'));
const InventoryManagementReportPage = lazy(() => import('./pages/inventoryManagementReport/InventoryManagementReportPage'));
const DetectionsReportPage = lazy(() => import('./pages/detectionsReport/DetectionsReportPage'));
const PreparationSheetsReportPage = lazy(() => import('./pages/preparationSheetsReport/PreparationSheetsReportPage'));
const AuditReportPage = lazy(() => import('./pages/auditReport/AuditReportPage'));
const SendPDFPage = lazy(() => import('./pages/sendPDF/SendPDFPage'));
const PrebillingListPage = lazy(() => import('./pages/prebillingList/PrebillingListPage'));
const ConciliationPatientPage = lazy(() => import('./pages/conciliationPatient/ConciliationPatientPage'));
const ConciliationStorePage = lazy(() => import('./pages/conciliationStore/ConciliationStorePage'));
const ReportInstitutionalApplicationsPage = lazy(() => import('./pages/reportInstitutionalApplications/ReportInstitutionalApplicationsPage'));

const AdminInstitutionsPage = lazy(() => import('./pages/adminInstitutions/AdminInstitutionsPage'));
const AdminDrugsPage = lazy(() => import('./pages/adminDrugs/AdminDrugsPage'));
const MaintainerServicesPage = lazy(() => import('./maintainers/maintainerServices/MaintainerServicesPage'));
const MaintainerLaboratoriesPage = lazy(() => import('./maintainers/maintainerLaboratories/MaintainerLaboratoriesPage'));
const MaintainerInfusionSetsPage = lazy(() => import('./maintainers/maintainerInfusionSets/MaintainerInfusionSetsPage'));
const MaintainerSolutionsPage = lazy(() => import('./maintainers/maintainerSolutions/MaintainerSolutionsPage'));
const MaintainerAdministrationRoutesPage = lazy(() => import('./maintainers/maintainerAdministrationRoutes/MaintainerAdministrationRoutesPage'));
const MaintainerLabelsPage = lazy(() => import('./maintainers/maintainerLabels/MaintainerLabelsPage'));
const MaintainerPrescriptionTypesPage = lazy(() => import('./maintainers/maintainerPrescriptionTypes/MaintainerPrescriptionTypesPage'));
const MaintainerMixingCentersPage = lazy(() => import('./maintainers/maintainerMixingCenters/MaintainerMixingCentersPage'));
const MaintainerPathologiesPage = lazy(() => import('./maintainers/maintainerPathologies/MaintainerPathologiesPage'));
const MaintainerProtocolsPage = lazy(() => import('./maintainers/maintainerProtocols/MaintainerProtocolsPage'));
const MaintainerDrugsPage = lazy(() => import('./maintainers/maintainerDrugs/MaintainerDrugsPage'));
const MaintainerInstitutionsPage = lazy(() => import('./maintainers/maintainerInstitutions/MaintainerInstitutionsPage'));
const MaintainerInstitutionsDetailPage = lazy(() => import('./maintainers/maintainerInstitutions/MaintainerInstitutionsDetailPage'));
const MaintainerUsersPage = lazy(() => import('./maintainers/maintainerUsers/MaintainerUsersPage'));


interface AppRoutesProps {
  setOptionMenu: (codeMenu: string) => void;
  setBreadcrumb: ( breadcrumb: any ) => void;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ setOptionMenu , setBreadcrumb }) => {
  const [loadingMessage , setLoadingMessage] = useState('Cargando...');
  return (
    <Suspense fallback={<LoadingScreen message={loadingMessage} />}>
      <Routes>
        <Route
          path='/'
          element={
            <RequireAuth>
              <div></div>
            </RequireAuth>
          }
        />
        <Route
          path='/searchPatient'
          element={
            <RequireAuth>
              <SearchPatientPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/preparationRequest'
          element={
            <RequireAuth>
              <PreparationRequestPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/applicationList'
          element={
            <RequireAuth>
              <ApplicationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/compApplicationList'
          element={
            <RequireAuth>
              <ComApplicationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/reportList'
          element={
            <RequireAuth>
              <ReportListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/reprints'
          element={
            <RequireAuth>
              <ReprintsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/printing'
          element={
            <RequireAuth>
              <PrintingPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/conciliationPatient'
          element={
            <RequireAuth>
              <ConciliationPatientPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/conciliationStore'
          element={
            <RequireAuth>
              <ConciliationStorePage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/reportInstitutionalApplications'
          element={
            <RequireAuth>
              <ReportInstitutionalApplicationsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/reportAutorization'
          element={
            <RequireAuth>
              <ReportAutorizationPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        
        <Route
          path='/storeCampaingList'
          element={
            <RequireAuth>
              <StoreCampaingListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/inventoryManagementReport'
          element={
            <RequireAuth>
              <InventoryManagementReportPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/elaborationList'
          element={
            <RequireAuth>
              <ElaborationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/pickingList'
          element={
            <RequireAuth>
              <PickingListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/sanitationI'
          element={
            <RequireAuth>
              <SanitationIListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/sanitationII'
          element={
            <RequireAuth>
              <SanitationIIListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/preElaboration'
          element={
            <RequireAuth>
              <PreElaborationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/production'
          element={
            <RequireAuth>
              <ProductionListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/postElaboration'
          element={
            <RequireAuth>
              <PostElaborationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/labeled'
          element={
            <RequireAuth>
              <LabeledListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/liberation'
          element={
            <RequireAuth>
              <ValidationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/validationReport'
          element={
            <RequireAuth>
              <ValidationReportListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/detectionsReport'
          element={
            <RequireAuth>
              <DetectionsReportPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/preparationSheets'
          element={
            <RequireAuth>
              <PreparationSheetsReportPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/billing'
          element={
            <RequireAuth>
              <LiberationListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/prebilling'
          element={
            <RequireAuth>
              <PrebillingListPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/sendPDF'
          element={
            <RequireAuth>
              <SendPDFPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />

        <Route
          path='/institutions'
          element={
            <RequireAuth>
              <AdminInstitutionsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />

        <Route
          path='/drugs'
          element={
            <RequireAuth>
              <AdminDrugsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />

        <Route
          path='/mantainerServices'
          element={
            <RequireAuth>
              <MaintainerServicesPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerLaboratories'
          element={
            <RequireAuth>
              <MaintainerLaboratoriesPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerInfusionSets'
          element={
            <RequireAuth>
              <MaintainerInfusionSetsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerSolutions'
          element={
            <RequireAuth>
              <MaintainerSolutionsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerAdministrationRoutes'
          element={
            <RequireAuth>
              <MaintainerAdministrationRoutesPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerLabels'
          element={
            <RequireAuth>
              <MaintainerLabelsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerPrescriptionTypes'
          element={
            <RequireAuth>
              <MaintainerPrescriptionTypesPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerMixingCenters'
          element={
            <RequireAuth>
              <MaintainerMixingCentersPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerPathologies'
          element={
            <RequireAuth>
              <MaintainerPathologiesPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerProtocols'
          element={
            <RequireAuth>
              <MaintainerProtocolsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerDrugs'
          element={
            <RequireAuth>
              <MaintainerDrugsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerInstitutions'
          element={
            <RequireAuth>
              <MaintainerInstitutionsPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerInstitutionsDetail'
          element={
            <RequireAuth>
              <MaintainerInstitutionsDetailPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/mantainerUsuarios'
          element={
            <RequireAuth>
              <MaintainerUsersPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
        <Route
          path='/auditReport'
          element={
            <RequireAuth>
              <AuditReportPage setOptionMenu={setOptionMenu} setBreadcrumb={setBreadcrumb} />
            </RequireAuth>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;